/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Audit_Details_Redaction_OccurrencesInputs */



/**
* | output |
* | --- |
* | "{count}×" |
*
* @param {Audit_Details_Redaction_OccurrencesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_redaction_occurrences = /** @type {((inputs: Audit_Details_Redaction_OccurrencesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Redaction_OccurrencesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}×`)
	return /** @type {LocalizedString} */ (`${i?.count}×`)
});